/* eslint-disable custom-imports/no-react-hot-toast-import */
import { Text } from "@/elements"
import { toast as hotToast, ToastOptions as RHTToastOptions, Toast } from "react-hot-toast"

interface ToastOptions extends RHTToastOptions {
  cta?: {
    text: string
    onClick: () => void
  }
}

type ToastType = "success" | "error" | "loading" | "custom"

const createToast = (message: string, type?: ToastType, options?: ToastOptions) => {
  if (!type) {
    if (!options?.cta) {
      return hotToast(message, options)
    } else {
      return hotToast((t: Toast) => <CTAToastBody message={message} t={t} options={options} />, options)
    }
  } else {
    if (options?.cta) {
      return hotToast[type]((t: Toast) => <CTAToastBody message={message} t={t} options={options} />, options)
    }
    return hotToast[type](message, options)
  }
}

const CTAToastBody = ({ message, t, options }: { message: string; t: Toast; options: ToastOptions }) => {
  return (
    <div className="flex w-full flex-row items-center justify-between">
      {message}
      {options?.cta ? (
        <Text
          variant="CTASmall"
          className="cursor-pointer select-none underline underline-offset-2"
          onClick={options.cta?.onClick}>
          {options.cta?.text}
        </Text>
      ) : null}
    </div>
  )
}

export const toast = Object.assign(
  (message: string, options?: ToastOptions) => createToast(message, undefined, options),
  {
    success: (message: string, options?: ToastOptions) => createToast(message, "success", options),
    error: (message: string, options?: ToastOptions) => createToast(message, "error", options),
    loading: (message: string, options?: ToastOptions) => createToast(message, "loading", options),
    custom: (message: string, options?: ToastOptions) => createToast(message, "custom", options),
    dismiss: (id?: string) => hotToast.dismiss(id),
  }
)
